// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareFilledSvg from "@fishx/icons-svg/es/asn/CheckSquareFilled";
import FishxIcon from '../components/FishxIcon';

var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareFilledSvg
  }));
};

CheckSquareFilled.displayName = 'CheckSquareFilled';
export default React.forwardRef(CheckSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckSquareFilled.js
// module id = 2195
// module chunks = 0